<script>
    import app from '../data/app.svelte.js';
    import persistent from '../data/persistent.svelte';
    import { currentSession, currentSessionId } from '../data/session.svelte.js';

    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';
    import { next, previous, goto, replace, first } from '../helpers/navigation.svelte.js';
    import { fetchApi } from '../helpers/api.svelte.js';
    import { normalizeTelephone } from '../helpers/phone.js';

    import Section from '../components/Section.svelte';
    import Navigation from '../components/Navigation.svelte';
    import Button from '../components/Button.svelte';
    import Back from '../components/Back.svelte';
    import Box from '../components/Box.svelte';
    import Legal from '../components/Legal.svelte';
    import Form from '../components/Customer/Form.svelte';

    import Icon from '../components/Icon.svelte';
    import arrowRightIcon from '../assets/icons/arrow-right.svg?raw';

    
    const current = 'customer';

    onMount(() => {
        if (currentSession.validate !== 'late') {
            replace('welcome', 'right');
        }
    });

    function goBack() {
        currentSession.customer = {
            firstname: null,
            lastname: null,
            email: null,
            telephone: null
        }

        replace(previous(current), 'left');
    }

    async function goNext() {
        if (!valid) {
            return;
        }

        // Check customer for validation requirement
        const form = new FormData();
        form.append('session', currentSessionId);
        form.append('client', currentSession.client);
        form.append('salon', currentSession.salon);
        form.append('guid', persistent.guid);
        form.append('name[firstname]', customer.firstname);
        form.append('name[lastname]', customer.lastname);
        form.append('email', customer.email);
        form.append('telephone', normalizeTelephone(customer.telephone));

        const data = await fetchApi({
            endpoint: 'OnlineAppointment.Remote.Customer/check',
            data: form
        });

        if (data.status === 'blocked') {
            replace('error/customer-blocked', 'right');
            return;
        }
        else if (data.status === 'rejected') {
            replace('error/customer-rejected', 'right');
            return;
        }
        else if (data.status === 'error') {
            replace('error/customer-failed', 'right');
            return;
        }
        else if (data.status === 'validate') {
            // Email validation required - store in pendingCustomer (not yet validated)
            currentSession.pendingCustomer = customer;
            goto('validate', 'right');
            return;
        }
        else if (data.status === 'ok') {
            persistent.customer = customer;
            currentSession.customer = customer;

            goto(next(current), 'right');
            return;
        }
    }
    

    /* Determine default values for customer form */

    let customer = {
        firstname: currentSession.customer.firstname || persistent.customer.firstname || '',
        lastname: currentSession.customer.lastname || persistent.customer.lastname || '',
        email: currentSession.customer.email || persistent.customer.email || '',
        telephone: currentSession.customer.telephone || persistent.customer.telephone || ''
    };

    let valid = $state(false);

    function onChange(value) {
        customer = value;
        valid = value.firstname && value.lastname && value.email && value.telephone;
    }

    if (customer.firstname || customer.lastname || customer.email || customer.telephone) {
        valid = true;
    }

    let privacyStatementUrl = $derived(app.settings.terms.privacy || app.salon.website);

</script>

<svelte:head>
    <title>{$_('appointment_title')} - {$_('customer')}</title>
</svelte:head>

<Section title={$_('customer')}>
    {#snippet back()}
        <Back onclick={goBack} />
    {/snippet}
    
    <Box>
        <p>{$_('appointment_details_required')}</p>

        <Form {...customer} {onChange} onSubmit={goNext} />
    </Box>

    <br>

    <Legal>
        {@html $_('privacy_consent', { values: { url: privacyStatementUrl } })}
    </Legal>

    {#snippet navigation()}
        <Navigation>
            <Button color="accent" onclick={goNext} disabled={!valid}>
                {$_('next')}
                <Icon data={arrowRightIcon} />
            </Button>
        </Navigation>
    {/snippet}
</Section>